import {
  createFileRoute,
  type SearchSchemaInput,
} from "@tanstack/react-router";
import type { PortfolioRouteLoaderDeps } from "~/features/portfolio/portfolio-route";

export interface PortfolioRouteSearch {
  action?: "deposit" | "sell" | "transfer" | "withdraw";
  approvalId?: string;
  operationId?: string;
  workflowId?: string;
}

type PortfolioRouteSearchInput = SearchSchemaInput & PortfolioRouteSearch;

export function toPortfolioRouteSearch(raw: unknown): PortfolioRouteSearch {
  if (!raw || typeof raw !== "object") {
    return {};
  }

  const record = raw as Record<string, unknown>;
  const action = record.action;
  const approvalId =
    typeof record.approvalId === "string" ? record.approvalId.trim() : "";
  const operationId =
    typeof record.operationId === "string" ? record.operationId.trim() : "";
  const workflowId =
    typeof record.workflowId === "string" ? record.workflowId.trim() : "";
  const result: PortfolioRouteSearch = {};

  if (
    action === "deposit" ||
    action === "sell" ||
    action === "transfer" ||
    action === "withdraw"
  ) {
    result.action = action;
  }

  if (approvalId.length > 0) {
    result.approvalId = approvalId;
  }

  if (operationId.length > 0) {
    result.operationId = operationId;
  }

  if (workflowId.length > 0) {
    result.workflowId = workflowId;
  }

  return result;
}

export const Route = createFileRoute("/_app/portfolio/$portfolioInstanceId")({
  validateSearch: (raw: PortfolioRouteSearchInput): PortfolioRouteSearch =>
    toPortfolioRouteSearch(raw),
  loaderDeps: ({ search }): PortfolioRouteLoaderDeps =>
    toPortfolioRouteSearch(search),
  loader: ({ context, deps, params }) => {
    void import("~/features/portfolio/portfolio-route").then(
      ({ preloadPortfolioRoute }) =>
        preloadPortfolioRoute({
          context,
          loaderDeps: deps,
          portfolioInstanceId: params.portfolioInstanceId,
        }),
    ).catch(() => undefined);
  },
});
